var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 246,
    viewBox: "0 0 416 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8015 160.32V133.752L59.1495 61.92H94.4095V132.44H107.038V160.32H94.4095V180H61.9375V160.32H8.8015ZM64.3975 98.164L41.7655 132.44H64.3975V98.164ZM310.536 160.32V133.752L360.884 61.92H396.144V132.44H408.772V160.32H396.144V180H363.672V160.32H310.536ZM366.132 98.164L343.5 132.44H366.132V98.164Z",
    fill: "#100828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.935 97.4043L238.918 53.1376C228.059 45.9502 215.115 42.5862 202.13 43.5771C189.94 44.52 178.579 50.1109 170.395 59.1939L212.935 97.4043Z",
    fill: "#F73E77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.934 100.404L255.753 163.918C262.722 160.502 268.958 155.759 274.11 149.953C298.168 122.757 293.137 78.041 262.876 50.8555C259.669 47.9736 256.242 45.3471 252.625 43L218.934 100.404Z",
    fill: "#F73E77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.935 100.404L133.868 79.8398C129.684 107.224 140.814 136.533 163.156 156.585C189.358 180.141 226.125 186.49 254.671 172.463L212.935 100.404Z",
    fill: "#F73E77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.906 92.0951L149.266 45.1132C145.607 49.0276 142.541 53.4572 140.167 58.2608C137.752 63.1458 136.039 68.3477 135.079 73.7122L198.906 92.0951Z",
    fill: "#F73E77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.d944e5069392e5b88d80b1536f893ab6.svg";
export { ForwardRef as ReactComponent };